import { PromotionMetadata } from '@core/Entities/Vehicle/VehiclePromotionMetadata.entity';
import { showBadge } from '@core/Utils/Promotions/getPromotions';
import Badge from '@gds/Badge/Badge';
import { BadgeColor } from '@gds/Badge/Badge.types';

interface PromotionBadeProps {
  promotion: PromotionMetadata;
}

const COLORS_MAP: Record<string, BadgeColor> = {
  mint: 'mint',
  sunbeamBlue: 'blue',
  mustangYellow: 'orange',
  oldFerrariRed: 'error',
  championshipWhite: 'neutral__light',
};

export const PromotionBadge = ({ promotion }: PromotionBadeProps) => {
  const {
    name,
    settings: { theme },
  } = promotion;

  return <Badge color={COLORS_MAP[theme]}>{name}</Badge>;
};

export const filterPromotionBadges = (
  promotions: PromotionMetadata[],
  page: string,
  hasDiscount?: boolean,
) =>
  promotions
    .map(
      promotion =>
        showBadge(promotion, page) && (
          <PromotionBadge promotion={promotion} key={promotion.promotionCode} />
        ),
    )
    .slice(0, hasDiscount ? 1 : 2);

export const PromotionBadges = ({
  promotions,
  page,
  hasDiscount,
}: {
  promotions: PromotionMetadata[];
  page: string;
  hasDiscount?: boolean;
}) => filterPromotionBadges(promotions, page, hasDiscount);
